import type { FieldConfig } from '../config/types'

/**
 * LPH-T35 FR-10: the optional work location on worker / EOR-AOR onboarding. Country is a places select that emits the ISO-2 code
 * (`valueField: 'isoCode'`; the default emits a place UUID the mutation would refuse). State is the full ISO 3166-2 code, shown once a
 * country is chosen; the submit mapping validates the pair (`onboardingWorkLocation`).
 */
export const workLocationFields: Record<'workCountry' | 'workState', FieldConfig> = {
  workCountry: {
    field: 'workCountry',
    id: 'workCountry',
    inputType: 'select',
    label: 'Work country',
    helpText: 'Where the worker works. It decides which leave policies and holiday calendar apply.',
    dataSource: { type: 'places', level: 'country', valueField: 'isoCode' },
  },
  workState: {
    field: 'workState',
    id: 'workState',
    inputType: 'textField',
    label: 'Work state / province',
    placeholder: 'e.g. CA-ON',
    helpText: 'Optional. The full code, for example CA-ON.',
    visibility: { not: { not: { var: 'workCountry' } } },
  },
}
